module.exports = __webpack_public_path__ + "static/media/react1-class.fd3f32f8.png";